import Image from 'next/image'
import { useTranslation } from 'src/utils/i18n'
import styles from './ContentLoading.module.css'

const ContentLoading = ({ label, fullScreen = false, className = '' }) => {
  const { t } = useTranslation('common')
  const text = label || t('Loading...')

  return (
    <div
      role='status'
      aria-live='polite'
      aria-label={text}
      className={`${styles.contentLoadingRoot} ${fullScreen ? styles.contentLoadingRootFullScreen : ''} ${className}`.trim()}
    >
      <Image
        src='/images/loading/spinner.svg'
        alt=''
        width={64}
        height={64}
        className={styles.contentLoadingSpinner}
        aria-hidden='true'
        priority
      />
      <p className={styles.contentLoadingLabel}>{text}</p>
    </div>
  )
}

export default ContentLoading
